module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiCn.02548b9.eot";